import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import TopRightTransition from '../../assets/img/section-transitions/slider-top-right.svg';
import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { useTranslation } from 'react-i18next';

import relaxace1 from '../../assets/img/slides/relaxace/vrpad-relaxace-1.webp';
import relaxace2 from '../../assets/img/slides/relaxace/vrpad-relaxace-2.webp';
import relaxace3 from '../../assets/img/slides/relaxace/vrpad-relaxace-3.webp';

import pavouci1 from '../../assets/img/slides/pavouci/vrpad-pavouci-1.webp';
import pavouci2 from '../../assets/img/slides/pavouci/vrpad-pavouci-2.webp';
import pavouci3 from '../../assets/img/slides/pavouci/vrpad-pavouci-3.webp';

import apartman1 from '../../assets/img/slides/apartman/vrpad-apartman-1.webp';
import apartman2 from '../../assets/img/slides/apartman/vrpad-apartman-2.webp';

import mri1 from '../../assets/img/slides/mri/vrpad-mri-1.webp';
import mri2 from '../../assets/img/slides/mri/vrpad-mri-2.webp';
import mri3 from '../../assets/img/slides/mri/vrpad-mri-3.webp';
import mri4 from '../../assets/img/slides/mri/vrpad-mri-4.webp';

import vytahy1 from '../../assets/img/slides/vytahy/vrpad-vytahy-1.webp';
import vytahy2 from '../../assets/img/slides/vytahy/vrpad-vytahy-2.webp';
import vytahy3 from '../../assets/img/slides/vytahy/vrpad-vytahy-3.webp';

import vysky1 from '../../assets/img/slides/vysky/vrpad-vysky-1.webp';
import vysky2 from '../../assets/img/slides/vysky/vrpad-vysky-2.webp';
import vysky3 from '../../assets/img/slides/vysky/vrpad-vysky-3.webp';
import vysky4 from '../../assets/img/slides/vysky/vrpad-vysky-4.webp';
import vysky5 from '../../assets/img/slides/vysky/vrpad-vysky-5.webp';
import vysky6 from '../../assets/img/slides/vysky/vrpad-vysky-6.webp';

import social1 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-3.webp';
import social2 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-4.webp';
import social3 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-5.webp';
import social4 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-6.webp';
import social5 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-7.webp';
import social6 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-8.webp';
import social7 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-9.webp';
import social8 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-10.webp';
import social9 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-11.webp';
import social10 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-12.webp';
import social11 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-park-1.webp';
import social12 from '../../assets/img/slides/social/vrpad-relaxace-socialni-fobie-park-2.webp';

const Slider = () => {
  const { t } = useTranslation();
  const [selectedSlideIndex, setSelectedSlideIndex] = useState<number | null>(null);

  const slides = [
    {
      title: t('slider.items.item1.title'),
      mainImage: pavouci1,
      images: [
        { src: pavouci1, caption: t('slider.items.item1.captions.image1', '') },
        { src: pavouci2, caption: t('slider.items.item1.captions.image2', '') },
        { src: pavouci3, caption: t('slider.items.item1.captions.image3', '') }
      ]
    },
    {
      title: t('slider.items.item2.title'),
      mainImage: vysky1,
      images: [
        { src: vysky1, caption: t('slider.items.item2.captions.image1', '') },
        { src: vysky2, caption: t('slider.items.item2.captions.image2', '') },
        { src: vysky3, caption: t('slider.items.item2.captions.image3', '') },
        { src: vysky4, caption: t('slider.items.item2.captions.image4', '') },
        { src: vysky5, caption: t('slider.items.item2.captions.image5', '') },
        { src: vysky6, caption: t('slider.items.item2.captions.image6', '') }
      ]
    },
    {
      title: t('slider.items.item3.title'),
      mainImage: relaxace1,
      images: [
        { src: relaxace1, caption: t('slider.items.item3.captions.image1', '') },
        { src: relaxace2, caption: t('slider.items.item3.captions.image2', '') },
        { src: relaxace3, caption: t('slider.items.item3.captions.image3', '') }
      ]
    },
    {
      title: t('slider.items.item4.title'),
      mainImage: mri1,
      images: [
        { src: mri1, caption: t('slider.items.item4.captions.image1', '') },
        { src: mri2, caption: t('slider.items.item4.captions.image2', '') },
        { src: mri3, caption: t('slider.items.item4.captions.image3', '') },
        { src: mri4, caption: t('slider.items.item4.captions.image4', '') }
      ]
    },
    {
      title: t('slider.items.item5.title'),
      mainImage: vytahy1,
      images: [
        { src: vytahy1, caption: t('slider.items.item5.captions.image1', '') },
        { src: vytahy2, caption: t('slider.items.item5.captions.image2', '') },
        { src: vytahy3, caption: t('slider.items.item5.captions.image3', '') }
      ]
    },
    {
      title: t('slider.items.item6.title'),
      mainImage: apartman1,
      images: [
        { src: apartman1, caption: t('slider.items.item6.captions.image1', '') },
        { src: apartman2, caption: t('slider.items.item6.captions.image2', '') }
      ]
    },
    {
      title: t('slider.items.item7.title'),
      mainImage: social1,
      images: [
        { src: social1, caption: t('slider.items.item7.captions.image1', '') },
        { src: social2, caption: t('slider.items.item7.captions.image2', '') },
        { src: social3, caption: t('slider.items.item7.captions.image3', '') },
        { src: social4, caption: t('slider.items.item7.captions.image4', '') },
        { src: social5, caption: t('slider.items.item7.captions.image5', '') },
        { src: social6, caption: t('slider.items.item7.captions.image6', '') },
        { src: social7, caption: t('slider.items.item7.captions.image7', '') },
        { src: social8, caption: t('slider.items.item7.captions.image8', '') },
        { src: social9, caption: t('slider.items.item7.captions.image9', '') },
        { src: social10, caption: t('slider.items.item7.captions.image10', '') },
        { src: social11, caption: t('slider.items.item7.captions.image11', '') },
        { src: social12, caption: t('slider.items.item7.captions.image12', '') }
      ]
    },
  ];

  return (
    <div className="bg-primary-background py-35 relative" id='vr-ve-zdravotnictvi'>
      <img
        src={TopRightTransition}
        alt={t('slider.transitionAlt')}
        className="absolute top-0 right-0 w-[30%] max-w-[400px] z-10"
      />

      <div className="mx-auto" style={{ maxWidth: "var(--width-container)" }}>
        <h2>{t('slider.title')} <span className="text-primary">{t('slider.highlight')}</span></h2>
      </div>

      <div className="mx-auto relative" style={{ maxWidth: '1800px' }}>
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          centeredSlides={true}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: true }}
          navigation
          breakpoints={{ 1024: { slidesPerView: 2 } }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              {({ isActive }) => (
                <div
                  className={`relative flex flex-col items-center justify-center transition-all duration-300 cursor-pointer ${!isActive ? 'scale-80 opacity-80' : 'scale-90'}`}
                  onClick={() => setSelectedSlideIndex(index)}
                >
                  <img
                    src={slide.mainImage}
                    alt={slide.title}
                    className="rounded-xl shadow-lg w-full h-full object-cover"
                  />
                  <div className="absolute left-5 top-5 bg-white text-primary px-6 py-2.5 rounded-full text-sm">
                    {slide.title}
                  </div>
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="mt-2 flex flex-col items-center animate-bounce text-secondary drop-shadow-sm z-20 pointer-events-none">
        <FontAwesomeIcon icon={faArrowUp} className="text-xl mb-1" />
        <span className="text-sm">{t('slider.clickText')}</span>
      </div>

      <div className="mx-auto mt-8" style={{ maxWidth: "var(--width-container)" }}>
        <a href="#kontakt" className="btn">{t('slider.tryButton')}</a>
      </div>

      {selectedSlideIndex !== null && (
        <Lightbox
          open={true}
          close={() => setSelectedSlideIndex(null)}
          slides={slides[selectedSlideIndex].images.map(img => ({ 
            src: img.src, 
            title: slides[selectedSlideIndex].title,
            description: img.caption || '',
            alt: img.caption || slides[selectedSlideIndex].title
          }))}
          plugins={[Thumbnails, Captions]}
          styles={{
            container: { backgroundColor: 'rgba(0, 0, 0, 0.9)' },
            slide: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
          }}
        />
      )}
    </div>
  );
};

export default Slider;
